let _debounce = require("lodash/debounce");

$(function () {
    let $window = $(window),

        //Number Flip Animation
        $numberFlipAnimation = $(".ws-animation-number--flip"),
        numberFlipAnimationTriggered = false;

    // Helper function to check if element is in viewport
    function isElementInViewport($element) {
        if (!$element.length) return false;
        const elementBounds = $element[0].getBoundingClientRect();
        return (
            elementBounds.top < $window.height() &&
            elementBounds.bottom > 0
        );
    }

    /**
     * Animate a flipping effect and format a given element's numerical text content to increment from 0 to a specified final number.
     * @param {jQuery} $element - The jQuery element to animate.
     * @param {number} number - The number to animate to.
     * @param {number} [animationDuration=1000] - The optional duration of the animation in milliseconds.
     */
    function numberFlipAnimation($element, number, animationDuration = 1000) {
        let finalNumber = number;
        if (String(finalNumber).includes(",")) {
            finalNumber = Number(finalNumber.replace(/,/g, ""));
        }

        $({ countNum: 0 }).animate(
            { countNum: finalNumber },
            {
                duration: animationDuration,
                easing: 'linear',
                step: function () {
                    let countNumValue = Math.round(this.countNum);
                    if (String(number).includes(",")) {
                        countNumValue = countNumValue.toLocaleString();
                    }
                    $element.text(countNumValue);
                },
                complete: function () {
                    $element.text(number);
                }
            }
        );
    }

    // Triggers the number flip animation when the element is in the viewport and hasn't been triggered yet.
    const debouncedTrigger = _debounce(function triggerNumberFlipAnimation() {
        if ($numberFlipAnimation.length && !numberFlipAnimationTriggered && isElementInViewport($numberFlipAnimation)) {
            $numberFlipAnimation.each(function () {
                let $element = $(this);
                numberFlipAnimation($element, $element.text());
            });
            numberFlipAnimationTriggered = true;
            $window.off('scroll resize', debouncedTrigger); // Remove handler after animation triggers
        }
    }, 100);

    if (!WS.isExperienceEditor()) {
        $window.on('scroll resize', debouncedTrigger);
        debouncedTrigger();
    }
});